<template>
  <div class="container-md home-container">
    <div v-show="user" class="grid">
      <div class="home-crd">
        <committee-events></committee-events>
      </div>
      <div class="home-crd">
        <div
          class="container-bg p-3 custom-scrollbar"
          style="height: 350px; box-shadow: unset"
        >
          <h3 class="text-center">NIEUWS</h3>
          <div
            v-for="(item, index) in newsitems.data"
            :key="index"
            class="flex-container flex-body p-2"
          >
            <div class="item text-white" style="flex: 18 1 0%">
              <p style="margin: 0">{{ item.title }}</p>
              <small style="color: lightgray; font-size: 10px" class="">{{
                item.created_at
              }}</small>
            </div>
            <div class="item">
              <button
                v-if="item.public == 1"
                data-target="#newsDescription"
                data-toggle="modal"
                @click="viewNews(item)"
                class="btn btn-small-mvn btn-sm btn-dark text-white close-bg"
              >
                Open
              </button>
            </div>
          </div>
          <div class="mt-2">
            <button
              v-if="newsitems.next_page_url"
              @click="getNewsItem(newsitems.next_page_url)"
              class="btn btn-sm mt-2 m-auto d-block btn-dark"
            >
              Laad meer
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="home-crd"> -->
      <committee-tasks :committees="allCommittees" is-home></committee-tasks>
      <!-- <div class="container-bg p-3 custom-scrollbar" style="height: 283px">
          <h3 class="text-center text-uppercase">Mijn Taken</h3>
          <div
            :class="{ done: task.active == 0 }"
            class="flex-container flex-body p-2 task"
            v-for="(task, index) in tasks.data"
            :key="'task_' + index"
          >
            <div class="item text-white" style="flex: 18 1 0%">
              <p style="margin: 0">{{ task.title }}</p>
            </div>
            <div class="item"></div>
          </div>
        </div> -->
      <!-- </div> -->

      <div
        class="container-bg p-3 custom-scrollbar"
        style="height: 283px"
        v-if="itemgroups.length"
      >
        <h3 class="text-center text-uppercase">
          Informatie
        </h3>
        <router-link
          :to="'/itemgroups/' + itemgroup.id + '/' + itemgroup.title_slug"
          style="text-decoration: none; color: inherit"
          v-for="(itemgroup, ind) in itemgroups"
          :key="'committe_itemgroup' + ind"
        >
          <div class="flex-container flex-body p-2">
            <div class="item text-white" style="flex: 0">
              <i class="fa fa-eye text-white"></i>
            </div>
            <div class="item text-white">
              <p style="margin: 0">{{ itemgroup.title }}</p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="home-crd" v-if="committees.length">
        <div class="container-bg p-3 custom-scrollbar" style="height: 283px">
          <h3 class="text-center text-uppercase">Mijn commissies</h3>
          <router-link
            :to="'/committees/' + committee.id + '/view/'"
            style="text-decoration: none; color: inherit"
            v-for="(committee, index) in committees"
            :key="'home_committee_' + index"
          >
            <div class="flex-container flex-body p-2">
              <div class="item" style="flex: 0">
                <img
                  :src="
                    committee.profile_image
                      ? committee.profile_image
                      : '/assets/icon.jpg'
                  "
                  style="
                    height: 50px;
                    width: 50px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                  "
                  alt=""
                />
              </div>
              <div class="item text-white">
                <p style="margin: 0">{{ committee.title }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="home-crd" v-if="groups.length">
        <div class="container-bg p-3 custom-scrollbar" style="height: 283px">
          <h3 class="text-center text-uppercase">Mijn Groepen</h3>
          <router-link
            :to="'/groups/' + committee.id + '/view/'"
            style="text-decoration: none; color: inherit"
            v-for="(committee, index) in groups"
            :key="'home_group_' + index"
          >
            <div class="flex-container flex-body p-2">
              <div class="item" style="flex: 0">
                <img
                  :src="
                    committee.profile_image
                      ? committee.profile_image
                      : '/assets/icon.jpg'
                  "
                  style="
                    height: 50px;
                    width: 50px;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                  "
                  alt=""
                />
              </div>
              <div class="item text-white">
                <p style="margin: 0">{{ committee.title }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="newsDescription"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content committee-modal">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close close-modal-button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-header">
            <h4 class="modal-title">{{ newsitem.title }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <p v-html="newsitem.content"></p>
              </div>
              <div class="col-lg-12">
                <button data-dismiss="modal" class="btn-dark float-right mt-3">
                  Sluiten
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommitteeEvents from "../committees/pages/committeeEvents.vue";
import CommitteeTasks from "../committees/pages/committeeTasks.vue";

export default {
  name: "home",
  components: {
    CommitteeEvents,
    CommitteeTasks,
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.auth.user,
    }),
  },
  data() {
    return {
      user: { events: [] },
      next_event: null,
      calendar_events: [],
      newsitems: {
        data: [],
        next_url: null,
      },
      tasks: {
        data: [],
        next_url: null,
      },
      committees: [],
      groups: [],
      newsitem: {},
      allCommittees: [],
      itemgroups: [],
    };
  },
  methods: {
    getNewsItem(url) {
      if (url == null) return false;

      url = url.split("v1/")[1];

      this.$store
        .dispatch("get", "api/v1/" + url)
        .then((data) => {
          this.newsitems.data = [...this.newsitems.data, ...data.data.data];
          this.newsitems.next_page_url = data.data.next_page_url;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTasks(url) {
      if (url == null) return false;

      url = url.split("v1/")[1];

      this.$store
        .dispatch("get", "api/v1/" + url)
        .then((data) => {
          this.tasks.data = [...this.tasks.data, ...data.data.data];
          this.tasks.next_page_url = data.data.next_page_url;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCommittees(url) {
      this.$store
        .dispatch("get", url)
        .then((data) => {
          this.committees = data.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGroups(url) {
      this.$store
        .dispatch("get", url)
        .then((data) => {
          this.groups = data.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    viewNews(item) {
      this.newsitem = item;
    },
    getItemgroups(url) {
      this.$store
        .dispatch("get", url)
        .then((data) => {
          this.itemgroups = data.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.$store.state.inner_sidebar = [];
    this.getNewsItem("api/v1/get-user-newsitems");
    this.getTasks("api/v1/get-user-task");
    this.getCommittees("api/v1/get-committe-or-group/3");
    this.getGroups("api/v1/get-committe-or-group/2");
    this.getItemgroups("api/v1/user-itemgroups");

    this.$store
      .dispatch("get", "api/v1/get-user-dashboard")
      .then((data) => {
        this.user = data.data;

        if (this.user.events.data.length > 0) {
          this.next_event = this.user.events.data[0];
        }

        this.calendar_events = [
          ...this.user.reoccuring_events,
          ...this.user.events.data,
        ].map((event) => {
          return {
            key: event.id,
            highlight: {
              start: { fillMode: "solid" },
              base: { fillMode: "light" },
              end: { fillMode: "solid" },
            },
            popover: {
              label: event.title,
            },
            dates: {
              start: Date.parse(event.date_start),
              end: Date.parse(event.date_end),
            },
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store.dispatch("get", "api/v1/committees-all").then((data) => {
      this.allCommittees = data.data.data;
    });

    this.$store.state.breadcrumbs = {
      title: "Home",
      links: [
        {
          title: "",
          href: "/home",
        },
      ],
    };
  },
};
</script>

<style scoped>
.card {
  border: unset;
  border-radius: unset;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;
  margin-top: 10px;
  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  margin-right: 10px;
  padding: 10px 0;
  width: auto;
}

.custom-scrollbar {
  overflow-y: scroll;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f4f5f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
  background-color: #f5f5f5;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #4192d9 0% 0% no-repeat padding-box;
  border-radius: 5px;
}

.tab-styling {
  padding: 5px !important;
  font-size: 16px !important;
}

.active {
  background-color: #4192d9 !important;
  border: #4192d9;
}

.vc-container {
  width: 100%;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }

  .delete-modal {
    max-width: 600px !important;
    margin: 1.75rem auto;
  }
}

.form-control,
.input-group-text {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}

.arrow_box {
  position: relative;
  background: white;
  border: 1px solid #4192d9;
  border-radius: 4px;
}

.arrow_box:after,
.arrow_box:before {
  bottom: 100%;
  left: 25%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.arrow_box:after {
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: white;
  border-width: 14px;
  margin-left: -57px;
}

.arrow_box:before {
  border-color: rgba(194, 225, 245, 0);
  border-bottom-color: #4192d9;
  border-width: 15px;
  margin-left: -58px;
}
.panel-heading .chevron:after {
  content: "\f0d7";
}
.panel-heading.collapsed .chevron:after {
  content: "\f0da";
}
</style>
